module.exports = __webpack_public_path__ + "static/media/depArr.affcc0e2.png";